import React from 'react';
import './loading.scss';

function LoadingComponent() {
  return <div className="loading" />;
}

LoadingComponent.displayName = 'Loading Component';
export default LoadingComponent;
